import {IntegrationAlphaBatchEntityService} from "./service/api/integration-alpha-batch-entity.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";

export const HA_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['ha.IntegrationAlphaBatchEntityStepActivityRequest', {route: '/ha/integrationAlphaBatchEntityStepActivityRequests'}],
            ['ha.IntegrationAlphaAuth', {route: '/ha/integrationAlphaAuths'}],
            ['ha.IntegrationAlphaBatchEntityStep', {route: '/ha/integrationAlphaBatchEntitySteps'}],
            ['ha.IntegrationAlphaBatchThreading', {route: '/ha/integrationAlphaBatchThreadings'}],
            ['ha.IntegrationAlphaSystem', {route: '/ha/integrationAlphaSystems'}],
            ['ha.IntegrationAlphaBatchEntity', {route: '/ha/integrationAlphaBatchEntitys', service: IntegrationAlphaBatchEntityService}],
            ['ha.IntegrationAlphaBatchEntityStepActivity', {route: '/ha/integrationAlphaBatchEntityStepActivitys'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
